import { useQuery } from '@tanstack/react-query';
import type { UserRef } from '@cyphex/types';
import { chatApi } from '../api';

const ME_KEY = ['chat', 'me'] as const;

/** The signed-in user. Cached forever — it changes only on re-auth. */
export function useMe(): UserRef | null {
  const { data } = useQuery({
    queryKey: ME_KEY,
    queryFn: () => chatApi.me(),
    staleTime: Number.POSITIVE_INFINITY,
    gcTime: Number.POSITIVE_INFINITY,
  });
  return data ?? null;
}
